import Utility from '@/utils/Utility'

export default {
  name: 'TypeImportant',
  props: {
    model: {
      type: Object,
      required: true,
    }
  },
  mounted () {

  },
  computed: {
    body() {
      return this.model.body
    },

    showSoundFile() {
      return this.model.soundFile
    },
    soundFile() {
      return this.model.soundFile
    },

    showLinkUrl() {
      return this.model.linkUrl
    },
    linkUrl() {
      return this.model.linkUrl
    },

    showWebSites() {
      return this.model.webSites && this.model.webSites.length
    },
    webSites() {
      return this.model.webSites.map(item => {
        return '<a href="' + Utility.sanitizeUrl(item.url) + '" target="_blank">' + item.name + '</a>'
      }).join('<br />')
    },
  },
}
